<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_227" data-name="Group 227" transform="translate(-3717.306 -280.254)">
    <g id="Group_320" data-name="Group 320">
      <circle id="Ellipse_174" data-name="Ellipse 174" cx="35.201" cy="35.201" r="35.201" transform="translate(3717.306 280.254)" fill="#fff"/>
      <g id="Group_226" data-name="Group 226">
        <circle id="Ellipse_175" data-name="Ellipse 175" cx="13.039" cy="13.039" r="13.039" transform="translate(3737.719 302.065)" fill="#1a1818"/>
        <line id="Line_84" data-name="Line 84" y2="11.694" transform="translate(3750.759 328.032)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
        <line id="Line_85" data-name="Line 85" x2="11.694" transform="translate(3744.912 333.879)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
        <g id="Group_225" data-name="Group 225">
          <line id="Line_86" data-name="Line 86" x2="11.694" transform="translate(3744.912 312.249)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
          <line id="Line_87" data-name="Line 87" x2="11.694" transform="translate(3744.912 317.961)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
        </g>
        <line id="Line_88" data-name="Line 88" x1="8.269" y2="8.269" transform="translate(3759.671 297.669)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
        <path id="Path_275" data-name="Path 275" d="M3760.773,296.985h7.8v7.8" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_03_c',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SC_02_03_c.vue